import { LoadedLei } from './LoadedLei';

export default LoadedLei;